import BRAND from './brandTokens';

const imsPalette = {
    primary: {
        light: BRAND.primary.light,
        main: BRAND.primary.main,
        dark: BRAND.primary.dark,
        contrastText: BRAND.primary.contrastText,
        // Accessible filled-button/stat-card variant (white text on coral).
        strong: BRAND.primary.strong,
    },
    secondary: {
        light: BRAND.secondary.light,
        main: BRAND.secondary.main,
        dark: BRAND.secondary.dark,
        contrastText: BRAND.secondary.contrastText,
    },
};

const lightPalette:any = {
    blueTheme: {
        palette: {
            primary: {
                light: '#e8eaf6',
                main: '#3f51b5',
                dark: '#283593',
                contrastText: '#fff',
            },
            secondary: {
                light: '#79f77d',
                main: '#43a047',
                dark: '#215623',
                contrastText: '#fff',
            },
            secondary2: {
                light: '#8c9eff',
                main: '#304ffe',
                dark: '#1a237e',
                contrastText: '#fff',
            },
        },
    },
    redTheme: {
        palette: {
            primary: {
                light: '#fce4ec',
                main: '#e91e63',
                dark: '#ad1457',
                contrastText: '#fff',
            },
            secondary: {
                light: '#ff80ab',
                main: '#ff4081',
                dark: '#880e4f',
                contrastText: '#fff',
            },
        },
    },
    imsTheme: {
        palette: imsPalette,
    },
    imsThemeBlue: {
        palette: imsPalette,
    },

}

export default lightPalette;
